module.exports = __webpack_public_path__ + "video/1800-1_YR_2022_Phishing.16f69b57.vtt";